import { useDispatch } from 'react-redux';
import { dismissError } from '../../../utils/errorDispatchers';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import styles from './GlobalErrorBanner.module.css';

const GlobalErrorBanner = ({ id, message }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <motion.div
      className={styles.globalErrorBanner}
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -50, opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className={styles.bannerContent}>
        <p className={styles.message}>{message}</p>
        <button
          onClick={() => dismissError(dispatch, id)}
          className={styles.dismissButton}
        >
          {t('dismiss')}
        </button>
      </div>
    </motion.div>
  );
};

export default GlobalErrorBanner;
